import "./PreQualificationForm.module.css";
import VaultHeader from "@/reusable_sections/Header";
import PreQualification from "./sections/PreQualification";
import PreQualificationForm from "./sections/PreQualificationForm";
import Eligibility from "./sections/Eligibility";
import VaultFooter from "@/reusable_sections/Footer";
export default function PreQualificationFormPage() {
  return <div>
      <VaultHeader />
      <PreQualification />
      <PreQualificationForm />
      <Eligibility />
      <VaultFooter />
    </div>;
}